module.exports = __webpack_public_path__ + "static/media/45@2x.3aad1602.png";